<template>
  <h5 class="mb-1 fs-7 text-gray-700 mb-2">Объект</h5>
  <template v-if="object">
    <div class="podft-list p-4 rounded border mb-3">
      <div class="podft-list__item" v-if="object.is_immovable">
        <div class="text-gray-600 fs-7"> Тип
          <span class="text-gray-800 float-end" v-html="object.is_immovable"></span>
        </div>
      </div>
      <div class="podft-list__item" v-if="object.insurance_sum">
        <div class="text-gray-600 fs-7">Страховая сумма
          <span class="text-gray-800 float-end" v-html="object.insurance_sum.toLocaleString('ru-RU')+' тг.'"></span>
        </div>
      </div>
      <div class="podft-list__item" v-if="object.franchise">
        <div class="text-gray-600 fs-7">Франшиза при повреждении
          <span class="text-gray-800 float-end" v-html="object.franchise+'%'"></span>
        </div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Франшиза при полной гибели
          <span class="text-gray-800 float-end">10%</span>
        </div>
      </div>
      <div class="podft-list__item" v-if="object.add_info">
        <div class="text-gray-600 fs-7 mb-1">Информацию об объекте</div>
        <span class="text-gray-800" v-html="object.add_info"></span>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="podft-list p-4 rounded border mb-3" v-for="item in list" :key="item.id ?? item.vin ?? item.number">
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7"> Гос. номер / VIN
          <span class="text-gray-800 float-end" v-html="plateOrVin(item)"></span>
        </div>
      </div>
      <div v-if="item.mark || item.model" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Авто
          <span class="text-gray-800 float-end">
            {{ item.mark }}
            {{ item.model }}
            {{ item.color }}
            {{ item.year }}
          </span>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: 'PolicyObject',
  props: {
    object: null,
    objects: null,
    vehicles: null
  },
  computed: {
    list() {
      if (this.vehicles?.length) return this.vehicles
      return this.objects ?? []
    }
  },
  methods: {
    plateOrVin(item) {
      return item.number ?? item.registration?.number ?? item.vin
    }
  }
}
</script>

<style scoped>

</style>
